<template>
  <v-app-bar
    app
    clipped-left
    fixed
  >
    <v-btn icon @click="$router.go(-1)">
      <v-icon>mdi-keyboard-backspace</v-icon>
    </v-btn>
    <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
    <v-progress-linear
        :active="saving"
        :indeterminate="saving"
        absolute
        bottom
        color="primary"
      ></v-progress-linear>
    <div class="flex-grow-1"></div>
  </v-app-bar>
</template>

<script>
export default {
  computed: {
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    saving() {
      if (this.$store.state[this.moduleName] !== undefined) {
        return this.$store.state[this.moduleName].saving || this.$store.state[this.moduleName].loading
      } else {
        return true
      }
    }
  },
  props: ['title']
}
</script>

<style>

</style>